import CLOSE_ICON from "@/assets/icons/close.svg";
import { FC } from "react";
import "./style.scss";

interface UpladedImageItemPropTypes {
  imageSrc: string;
  onRemove?: () => void;
}

const UploadedImageItem: FC<UpladedImageItemPropTypes> = ({
  imageSrc,
  onRemove,
}) => {
  return (
    <div className="uploaded-item">
      {onRemove && (
        <button onClick={onRemove}>
          <img src={CLOSE_ICON} alt="close-btn-icon" />
        </button>
      )}
      <img className="uploaded-image" src={imageSrc} alt="uploaded" />
    </div>
  );
};

export default UploadedImageItem;
